import { Pipe, PipeTransform } from '@angular/core';
import { getProperty } from '@grid/utils/object';

@Pipe({
  name: 'filterByProperty',
})
export class FilterByPropertyPipe implements PipeTransform {
  transform(
    list: any[],
    propertyName: string,
    value?: any,
    operator: 'equals' | 'notEquals' = 'equals'
  ): any[] {
    if (!list) {
      return [];
    }

    if (!propertyName || !this.hasValue(value) || value === -1) {
      return list;
    }

    return list.filter((item) =>
      operator === 'equals'
        ? getProperty(item, propertyName) === value
        : getProperty(item, propertyName) !== value
    );
  }

  private hasValue(value: any): boolean {
    return value !== null;
  }
}
